import { callAPI, HTTPMethod } from "./API";
import { IcsoeSisubReportRequest, IcsoeSisubReport } from "../model/IcsoeSisubReport";

export async function getZipIcsoeSisub(tenantId: string, request: IcsoeSisubReportRequest): Promise<IcsoeSisubReport> {
    return await callAPI(`/tenants/${tenantId}/icsoe-sisub/report`, {
        method: HTTPMethod.POST,
        body: request
    });
}